/**
 * Maps the given form values to a structured payload for submission.
 *
 * @param {Object} params - The parameters received from the form.
 * @param {string} params.universitySlug - The slug identifier for the university.
 * @param {{label: string, value: string}} [params.countrySelection] - Optional country selection with a label and a value.
 * @param {{name?: string}} [params.domesticRegionSelection] - Optional domestic region selection.
 * @param {boolean} params.acceptMarketing - Flag indicating whether marketing materials are accepted.
 * @param {Array<{label: string, value: string}>} [params.degrees] - Optional degrees with labels and values.
 * @param {string} [params.degreeLevel] - Optional degree level.
 * @param {string} [params.dateOfEntry] - Optional date of entry; format should be YYYY-MM.
 * @param {unknown} params.unibuddyPrivacyChecked - // TODO: Remove this field once the old register pages are removed
 * @param {unknown} params.universityPrivacyChecked - // TODO: Remove this field once the old register pages are removed
 * @param {unknown} params.privacyPolicy - // TODO: Remove this field once the old register pages are removed
 * @param {Object} params.sourceTrackingParams - Tracking parameters for source attribution.
 * @param {{label: string, value: {id?: string, name?: string, locale?: string}}} [params.localePreference] - Optional locale preference with a label and a value.
 * @param {Object} [customAttributes] - Additional custom attributes not explicitly defined in the form model.
 * @returns {Object} - The structured payload ready for submission, including both predefined and custom attributes.
 */
export const mapValuesToPayload = ({
    universitySlug,
    countrySelection,
    domesticRegionSelection,
    acceptMarketing,
    degrees,
    degreeLevel,
    dateOfEntry,
    unibuddyPrivacyChecked,
    universityPrivacyChecked,
    privacyPolicy,
    sourceTrackingParams,
    localePreference,
    ...customAttributes
}) => ({
    variables: {
        countryId: countrySelection ? countrySelection.value : undefined,
        domesticRegion: domesticRegionSelection ? domesticRegionSelection.name : undefined,
        universitySlug,
        acceptMarketing,
        degreeLevel,
        degreesInterested: (degrees || []).map((d) => d.value),
        dateOfEntry: dateOfEntry === "" ? null : dateOfEntry,
        customAttributes: Object.entries(customAttributes).map(([key, value]) => ({
            value,
            attribute: key,
        })),
        sourceTrackingParams,
        localePreference: localePreference ? localePreference.value : undefined,
    },
});
